<div class="empty-state" [ngClass]="{'minimal': variant === 'minimal'}">
  <div class="empty-state-content">
    @if(showIcon){
    <div class="empty-state-icon" [ngClass]="'icon-' + iconSize">
      <lucide-icon [name]="icon" class="w-full h-full"></lucide-icon>
    </div>
    }

    <div class="empty-state-text">
      <h3 class="empty-state-title">{{ title }}</h3>
      <p class="empty-state-description">{{ description }}</p>
    </div>
  </div>
</div>
